import { Suspense, useEffect } from "react";
import { useSelector } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { env } from "~/env";
import { SideBarCalculator } from "../components/Calculator/desktop/SideBarCalculator";
import { useCalculatorType } from "../components/Calculator/hooks";
import { ScrollToTop } from "../components/ScrollToTop";
import { isCalculatorAvailable } from "../helpers/const";
import { getCookie } from "../helpers/helpers";
import { insertLiveTexScript } from "../helpers/insertLiveTexScript";
import { getStepIndex, getStepUrl } from "../helpers/steps";
import { usePrevious } from "../helpers/usePrevious";
import {
  selectIsAuth,
  selectLastStep,
  selectUserPhone,
} from "../store/selectors";
import "./index.css";

const auth = "Авторизован";
const authType = {
  0: "Нет",
  1: "Да",
};
export const AppRouter = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const calculatorType = useCalculatorType();
  const isAuth = useSelector(selectIsAuth);
  const phone = useSelector(selectUserPhone);
  const lastStep = useSelector(selectLastStep);

  const prevAuth = usePrevious(isAuth);

  const yandexID = getCookie("_ym_uid");

  const insertScriptLiveTex = async (id) => {
    window.LiveTex = {
      onLiveTexReady() {
        const body = {
          [auth]: isAuth ? authType[1] : authType[0],
          yandexID: getCookie("_ym_uid"),
          "Телефон клиента": phone,
        };
        window.LiveTex.setConversationAttributes(body);
      },
    };
    insertLiveTexScript(id);
  };

  // не пускаем пользователя дальше текущего шага в анкете
  useEffect(() => {
    if (!lastStep) return;

    const lastStepIndex = Number(getStepIndex(lastStep));
    const currentStepIndex = getStepIndex(location.pathname);
    if (currentStepIndex === null) return;

    if (currentStepIndex > lastStepIndex) {
      const [url, state] = getStepUrl(lastStepIndex);
      navigate(url, { replace: true, state });
    }
  }, [lastStep, location.pathname]);

  useEffect(() => {
    if (!env.VITE_LIVETEX_ENABLED) {
      return;
    }
    if (!env.VITE_LIVETEX_ID) {
      console.error("Не указан ID для LiveTex");
      return;
    }
    insertScriptLiveTex(env.VITE_LIVETEX_ID);
  }, []);

  useEffect(() => {
    const body = {
      [auth]: isAuth ? authType[1] : authType[0],
      yandexID,
      "Телефон клиента": phone,
    };
    if (window.LiveTex && window?.LiveTex?.setConversationAttributes) {
      window.LiveTex.setConversationAttributes(body);
    }

    if (
      !isAuth &&
      prevAuth !== isAuth &&
      window.LiveTex &&
      window?.LiveTex?.reinit
    ) {
      window.LiveTex.reinit();
    }
  }, [isAuth, phone, yandexID]);

  if (!isCalculatorAvailable(location.pathname)) {
    return (
      <div className="body">
        <ScrollToTop />
        <main className="page-registration">
          <div className="container">
            <Suspense fallback={<div />}>
              <Outlet />
            </Suspense>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="body">
      <ScrollToTop />
      <main className="page-registration">
        <div className="container">
          <div className="calculator-wrapper">
            <div className="content registration-col">
              <Suspense fallback={<div />}>
                <Outlet />
              </Suspense>
            </div>
            <SideBarCalculator calculatorType={calculatorType} />
          </div>
        </div>
      </main>
    </div>
  );
};
